import { render, staticRenderFns } from "./DashboardAffiliateManager.vue?vue&type=template&id=2c69ef25&scoped=true"
import script from "./DashboardAffiliateManager.vue?vue&type=script&lang=js"
export * from "./DashboardAffiliateManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c69ef25",
  null
  
)

export default component.exports